export default __webpack_public_path__ + "static/media/Aditya.f52c8e46.jpg";